import { render, staticRenderFns } from "./SubActivitybar.vue?vue&type=template&id=22ed7dde"
import script from "./SubActivitybar.vue?vue&type=script&lang=js"
export * from "./SubActivitybar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports